// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Duzd","textarea":"styles_textarea__2KlTr"};